import React from "react";
import "../Utility/loading.css";

const LoaderIndicator = () => {
  return (
    <div className="loader-center">
      <div className="refresher">
        <div className="arc1 blue"></div>
        <div className="arc2 black"></div>
      </div>
    </div>
  );
};

export default LoaderIndicator;
